module.exports = __webpack_public_path__ + "img/20200321104717QQ截图20190624162012.9134d2a4.png";